var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('h2',{staticClass:"fs-18 fw-400 primary-blue--text"},[_vm._v("Speaker: "+_vm._s(_vm.speaker.displayName))]),(_vm.speaker.publicationOrganization)?_c('p',{staticClass:"fs-14 mt-2 primary-blue--text"},[_vm._v(" "+_vm._s(_vm.speaker.publicationOrganization)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }